import { CommonResponseModel } from "../../../../../../../../../../../../../../Models/tableDetailsModel";
import { IAgentProductDetails } from "../../../../../../../../../../../../agentDetail.model";
import { NO_AVAILABLE_PRODUCTS_AND_COMMISSIONS_FOUND } from "../../../../../../../../../../../../agents.constants";
import { AvailableProductsAndCommissionsResponse } from "./addProduct.models";
import { ProductSelections } from "./components/productSelection/productSelection.index";

type ProductsResponse = CommonResponseModel<AvailableProductsAndCommissionsResponse[]>;

export const isNoProductsAvailableResponse = (response: ProductsResponse): boolean =>
    response.error === NO_AVAILABLE_PRODUCTS_AND_COMMISSIONS_FOUND;

export const buildInitialSelections = (
    existingProducts: IAgentProductDetails[]
): ProductSelections => {
    const selections: ProductSelections = {};
    existingProducts.forEach((product) => {
        selections[product.productUid] = product.commissionUid;
    });
    return selections;
};

export const getPrefillWritingNumber = (existingProducts: IAgentProductDetails[]): string =>
    existingProducts.find((product) => product.agentWritingNumber)?.agentWritingNumber ?? "";
